module.exports = __webpack_public_path__ + "img/urkunde.ad4f6657.jpg";